module.exports = __webpack_public_path__ + "static/media/d13ru.aa706cab.pdf";